export const buildRedirectHandler = (url, message) => ($message, { commit, dispatch } = {}) => {
  try {
    if (commit && message) {
      dispatch('addAndSaveMessage', {
        role: 'assistant',
        content: message,
      });
    }

    return { redirectUrl: url };
  } catch (error) {
    if (commit) {
      dispatch('addAndSaveMessage', {
        role: 'assistant',
        content: 'Sorry, there was an error redirecting you.',
      });
    }
  }
};

export const handleRedirectToFileBrowser = buildRedirectHandler(
  '/file/browser/files',
  'Redirecting you to the File Browser...'
);

export const handleRedirectToFileBrowserProducts = buildRedirectHandler(
  '/file/browser/products',
  'Redirecting you to the File Browser...'
);